import { z } from 'zod'

export const nullifyAppointmentSchema = z.object({
	description: z.string().min(1, { message: 'Required' }),
	idConsultaLigacao: z.number().nullable().optional(),
})
